import React, { useContext } from 'react';
import { LPText } from '../../styles';
import { ContentWrapper } from '../styles';
import BookingNav from './BookingNav';
import BrandFooter from './BrandFooter';
import { PageContext } from '../context';

const BookingConfirm = () => {
  const context = useContext(PageContext);
  const { submitBookingData } = context;

  return (
    <>
      <ContentWrapper>
        <LPText padded w800>
          Almost done 💪 - please review your selections and click confirm 🙏!
        </LPText>
        <BookingNav isExpanded />
      </ContentWrapper>

      <BrandFooter disabled={false} title="Confirm &amp; Book" handleClick={submitBookingData} />
    </>
  );
};

BookingConfirm.propTypes = {};

export default BookingConfirm;
